import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const labelVariants = cva(
  'block text-sm font-medium text-gray-700 dark:text-gray-300',
  {
    variants: {
      variant: {
        default: '',
        error: 'text-red-600 dark:text-red-400',
        required: "after:ml-0.5 after:text-red-500 after:content-['*']",
      },
      size: {
        sm: 'text-xs',
        md: 'text-sm',
        lg: 'text-base',
      },
    },
    defaultVariants: { variant: 'default', size: 'md' },
  }
)

export interface LabelProps
  extends
    React.LabelHTMLAttributes<HTMLLabelElement>,
    VariantProps<typeof labelVariants> {
  required?: boolean
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, variant, size, required, children, ...rest }, ref) => {
    const appliedVariant =
      required && variant !== 'error' ? 'required' : variant
    return (
      <label
        ref={ref}
        className={cn(
          labelVariants({ variant: appliedVariant, size, className })
        )}
        {...rest}
      >
        {children}
      </label>
    )
  }
)

Label.displayName = 'Label'

export { labelVariants }
